import React from 'react';
import {Row, Card, Col, ListGroup, Button} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';

export default function UserPosts(props) {
  let history = useHistory();

  const cards = props.posts.map((post) => {
    let formattedDate = post.date.toDateString();
    formattedDate = formattedDate.substring(formattedDate.indexOf(" ") + 1);
    let textSectors;
    post.sector.forEach((sector, index) => {
      if (sector) {
        if (index === 0) textSectors = sector;
        else textSectors += `, ${sector}`;
      }
    }); 

    return (
    <ListGroup.Item className="user-post-card" key={post.postID} onClick={() => history.push(`/users/${props.authorID}/posts/${post.postID}`)}>
      <Row className="mb-1">
        <Col xs={10} className="font-weight-bold user-post-summary mr-auto">{post.summary}</Col>
        <Col xs={2}  className="font-weight-bold text-right">+{post.upvotes}</Col>
      </Row>
      <p className="user-post-date">{formattedDate}</p>
      <p className="user-post-tags">{textSectors}. {`${post.city}, ${post.region}, ${post.country}`}.</p>
    </ListGroup.Item>
    );
  })

  return (
    <Row className="mt-3">
      <Card className="w-100 mx-3 text-left">
        <ListGroup>
          {cards}
        </ListGroup>
      </Card>

      <Button 
        className="mx-auto mt-3"
        variant={props.noMore ? "outline-danger" : "outline-success"} 
        disabled={props.noMore ? true : false} 
        onClick={props.handleLoad}>
        {props.noMore ? 'All Posts Loaded.' : 'Load More'}</Button>
    </Row> 
  )
}